import { getActiveSpectra } from './getActiveSpectra';
export function getActiveSpectraAsObject(state) {
    const activeSpectra = getActiveSpectra(state);
    if (!activeSpectra || activeSpectra?.length === 0)
        return null;
    const activeSpectraObject = {};
    for (const activeSpectrum of activeSpectra) {
        activeSpectraObject[activeSpectrum.id] = activeSpectrum.index;
    }
    return activeSpectraObject;
}
export function isActiveSpectrum(activeSpectra, id) {
    return !!(activeSpectra && id in activeSpectra);
}
